import { render, staticRenderFns } from "./CompanyScore.vue?vue&type=template&id=dc01e03a"
import script from "./CompanyScore.vue?vue&type=script&lang=js"
export * from "./CompanyScore.vue?vue&type=script&lang=js"
import style0 from "./CompanyScore.vue?vue&type=style&index=0&id=dc01e03a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports